/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { Grid, IconButton, InputAdornment, TextField } from "@material-ui/core";
import { Search, Settings } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { ActionButtons } from "../../../../components/Common";
import { useDebounce } from "../../../../hooks";

const AgentExtensionsActionsHeader = ({ setShowSyncAgentModal, filteredTerm, setShowGlobalSettingsModal }) => {
	const [searchTerm, setSearchTerm] = useState("");
	const debouncedSearchTerm = useDebounce(searchTerm, 200);

	useEffect(() => {
		filteredTerm(debouncedSearchTerm);
	}, [debouncedSearchTerm, filteredTerm]);

	const onSearchChanged = (e) => {
		setSearchTerm(e.target.value);
	};

	return (
		<Grid container justifyContent="space-between">
			<div className="col-12 col-lg-4 d-flex justify-content-start align-items-end mt-3 pr-0">
				<TextField
					onFocus={(e) => e.target.select()}
					autoComplete="new-password"
					value={searchTerm}
					fullWidth
					onChange={onSearchChanged}
					label="Search by Username or Extension"
					InputProps={{
						style: { height: 29 },
						startAdornment: (
							<InputAdornment position="start">
								<Search />
							</InputAdornment>
						),
					}}
				/>
			</div>
			<div className="col-12 col-lg-4 d-flex flex-wrap align-items-center justify-content-end mt-3 pl-0">
				<IconButton style={{ right: "10px" }} color="inherit" onClick={() => setShowGlobalSettingsModal(true)}>
					<Settings />
				</IconButton>
				<ActionButtons showCancel onCancel={() => setShowSyncAgentModal(true)} cancelLabel="Sync Agents" />
			</div>
		</Grid>
	);
};

export default AgentExtensionsActionsHeader;
